import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aca25796"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-warp" }
const _hoisted_2 = { class: "content-warp-item-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-item-box-bg" }, null, -1))
const _hoisted_4 = { class: "content-warp-item-box-text" }
const _hoisted_5 = { class: "content-warp-circle-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-circle-box-white" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-circle-box-border" }, null, -1))
const _hoisted_8 = { class: "content-warp-circle-box-icon1" }
const _hoisted_9 = { style: {"position":"absolute"} }
const _hoisted_10 = ["id"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-circle-item-r" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "content-name" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { baseSvg, svg2 } from './svg-components/index';
import { ref, onMounted } from 'vue';
import { selfAdaption, useDataAssembly } from './hooks';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-2-2',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
let tipDom = ref(null);

let _dataArr = useDataAssembly(
  props.tableHeaderList,
  props.tableDataList,
  true
);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  const leftDom = TaskRef.value.querySelectorAll(
    '#circle-1'
  ) as NodeListOf<HTMLDivElement>;
  const rightDom = TaskRef.value.querySelectorAll(
    '#circle-2'
  ) as NodeListOf<HTMLDivElement>;
  if (leftDom.length + rightDom.length == 6) {
    leftDom[0].style.transform = `rotate(${45}deg)`;
    leftDom[1].style.transform = `rotate(${2}deg)`;
    leftDom[2].style.transform = `rotate(${-41}deg)`;
    rightDom[0].style.transform = `rotate(${-40}deg)`;
    rightDom[1].style.transform = `rotate(${3}deg)`;
    rightDom[2].style.transform = `rotate(${46}deg)`;
  }
  if (leftDom.length + rightDom.length == 5) {
    leftDom[0].style.transform = `rotate(${45}deg)`;
    leftDom[1].style.transform = `rotate(${2}deg)`;
    leftDom[2].style.transform = `rotate(${-41}deg)`;
    rightDom[0].style.transform = `rotate(${-18}deg)`;
    rightDom[1].style.transform = `rotate(${23}deg)`;
  }
  if (leftDom.length + rightDom.length == 4) {
    leftDom[0].style.transform = `rotate(${23}deg)`;
    leftDom[1].style.transform = `rotate(${-18}deg)`;
    rightDom[0].style.transform = `rotate(${-18}deg)`;
    rightDom[1].style.transform = `rotate(${23}deg)`;
  }
  if (leftDom.length + rightDom.length == 3) {
    leftDom[0].style.transform = `rotate(${22}deg)`;
    leftDom[1].style.transform = `rotate(${-18}deg)`;
    rightDom[0].style.transform = `rotate(${3}deg)`;
  }
  if (leftDom.length + rightDom.length == 2) {
    leftDom[0].style.transform = `rotate(${2}deg)`;
    rightDom[0].style.transform = `rotate(${3}deg)`;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "patient-sex",
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "content",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_dataArr).tipData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "content-warp-item",
            key: index,
            style: _normalizeStyle({
            '--left': `${index + 1 == 1 ? '188px' : 'none'}`,
            '--right': `${index + 1 == 2 ? '188px' : 'none'}`
          })
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (item2, index2) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index2,
                  class: "content-warp-item-box-r",
                  style: _normalizeStyle({
                '--colors': `var(--theme-color-${item2[item2.length - 1]},#000)`
              }),
                  ref_for: true,
                  ref_key: "tipDom",
                  ref: tipDom
                }, [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.slice(0, item2.length - 1), (item3, index3) => {
                        return (_openBlock(), _createElementBlock("div", { key: index3 }, _toDisplayString(item3.label) + "：" + _toDisplayString(item3.value), 1))
                      }), 128))
                    ])
                  ])
                ], 4))
              }), 128))
            ])
          ], 4))
        }), 128)),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(baseSvg), { style: {"position":"absolute","z-index":"1"} }),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(svg2))
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_dataArr).tipData, (item2, index2) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index2,
              class: "content-warp-circle",
              style: _normalizeStyle({
              '--rotate': `${index2 + 1 == 1 ? '-92' : '89'}deg`
            })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2, (item3, index3) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: `circle-${index2 + 1}`,
                  key: index3,
                  class: "content-warp-circle-item",
                  style: _normalizeStyle({
                '--color': `var(--theme-color-${item3[item3.length - 1]},#000)`
              })
                }, _hoisted_12, 12, _hoisted_10))
              }), 128))
            ], 4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_dataArr).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` }),
              key: index
            }, [
              _hoisted_14,
              _createElementVNode("div", null, _toDisplayString(item.value), 1)
            ], 4))
          }), 128))
        ])
      ])
    ], 512)
  ], 4))
}
}

})